export const DIRECT_WHITELISTED = 'directWhitelisted';
export const DIRECT_BLACKLISTED = 'directBlacklisted';
export const GROUP_WHITELISTED = 'groupWhitelisted';
export const GROUP_BLACKLISTED = 'groupBlacklisted';